<template>
    <div class="major">
        <img src="../../../assets/images/artEmpty.png">
        <div class="major-text">coming soon</div>
    </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Tab, Tabs } from 'vant'

export default {
    name: 'artTab',
    components: {
        vanTab: Tab,
        vanTabs: Tabs,
    },
    data() {
        return {

        }
    },
    created() {},
    mounted() {},
    beforeDestroy() {},
    computed: {
        ...mapGetters([
            'token',
            'styleType',
            'isDirection',
            'languageName',
            'language',
            'isApp',
        ]),
    },
    watch: {},
    methods: {},
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/variableName.scss';
@import '../../../style/mixin';
.major{
    display: flex;
    align-items: center;
    flex-direction: column;
    img{
        width: torem(230);
        height: torem(222);
    }
    &-text{
        font-size: 40px;
        font-family: HarmonyOS Sans SC, HarmonyOS Sans SC;
        font-weight: 500;
        color: #C3CFDD;
    }
}
</style>


// WEBPACK FOOTER //
// src/view/InscriptionArea/compontents/artTab.vue